// extracted by mini-css-extract-plugin
export default {"menu-mobile":"MenuMobile_menu-mobile__pA26X","menu-mobile--open":"MenuMobile_menu-mobile--open__FcdfG"};